import { useEditGroup } from '@repo/api/group/useEditGroup';
import { useGetGroup } from '@repo/api/group/useGetGroup';
import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { groupScheduleMeetingSchema, type GroupScheduleSchema } from '@repo/schemas/group/groupSchedule';

import { GroupScheduleDialog } from '@/components/features/manage/manage-groups/GroupScheduleDialog';
import { toasterMessageHandler } from '@/lib/toaster-message-handler';

interface EditGroupScheduleProps {
  id?: number;
  open: boolean;
  onOpenChange: (value: boolean) => void;
}

export default function EditGroupSchedule(editGroupScheduleProps: EditGroupScheduleProps) {
  const { id, open, onOpenChange } = editGroupScheduleProps;

  const { data: groupData } = useGetGroup(id);
  const { mutateAsync: editGroup, isPending } = useEditGroup();

  const handleSubmit = async (schedule: GroupScheduleSchema) => {
    if (!id) return;

    const encodedPayload = {
      ...schedule,
      meetings: schedule.meetings.map((meeting) => groupScheduleMeetingSchema.decode(meeting)),
    };

    await editGroup({
      id,
      schedule: encodedPayload,
    }).catch((error) => {
      toasterMessageHandler(baseErrorMessages, error);
    });
  };

  return <GroupScheduleDialog open={open} onOpenChange={onOpenChange} onSubmit={handleSubmit} isPending={isPending} initialValue={groupData?.schedule ?? undefined} />;
}
